import { useMemo } from "react";

 const CustomTooltip = (props: any) => {
  const data = useMemo(
    () => props?.api?.getDisplayedRowAtIndex(props?.rowIndex)?.data,
    []
  );

  return (
    <div
      className="custom-tooltip"
      // style={{ backgroundColor: props.color || 'white' }}
      style={{
        backgroundColor: "#6a7587",
        height: "1.4rem",
        justifyContent: "center",
        alignItems: "center",
        color:"#fff"
      }}
    >
      <span
        style={{
          paddingLeft: props.message !== undefined ? "0.5rem" : "0rem",
          paddingRight: props.message !== undefined ? "0.5rem" : "0rem",
        }}
      >
        {props.message}
      </span>
    </div>
  );
};

export  default CustomTooltip